import styled from 'styled-components'

export const MainContainer = styled.div<React.HTMLAttributes<HTMLDivElement>>`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 900px;
    z-index: 9999;
    @media screen and (max-width: 600px) {
        height: 900px;
    }
`

export const PictureContainer = styled.div<React.HTMLAttributes<HTMLDivElement>>`
    display: flex;
    justify-content: center;
    margin-top: 8rem;
`

export const Picture = styled.img<React.ImgHTMLAttributes<HTMLImageElement>>`
    border-radius: 100%;
    width: 250px;
    height: 250px;
    background-size: cover;
    object-fit: cover;
    border: 5px solid #f0f0f0; 
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 
                0 6px 20px rgba(0, 0, 0, 0.19);
`

export const NameContainer = styled.div<React.HTMLAttributes<HTMLDivElement>>`
    display: flex;
    justify-content: center;
    margin-top: 3rem;
`

export const Name = styled.h1<React.HTMLAttributes<HTMLHeadingElement>>`
    font-family: ${({ theme }) => theme.fonts.poppins};
    color: black;
    font-size: 3rem;
    font-weight: 300;
    text-align: center;
`

export const StudiesContainer = styled.div<React.HTMLAttributes<HTMLDivElement>>`
    margin-top: 3rem;
    display: flex;
    justify-content: center;
    flex-direction: column;

    @media screen and (max-width: 600px) {
        flex-direction: column;
    }
`

export const StudiesTitles = styled.h3<React.HTMLAttributes<HTMLHeadingElement>>`
    font-family: ${({ theme }) => theme.fonts.poppins};
    font-size: 2.5rem;
    margin-bottom: 2rem;
    margin-right: 1rem;
    margin-left: 1rem;
    text-align: center;
    font-weight: 700;
`
export const ButtonContainer = styled.div<React.HTMLAttributes<HTMLDivElement>>`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 3rem;
    @media screen and (max-width: 600px) {
        flex-direction: column;
    }
`
